<template>
  <el-dialog
    title="View Tagged Data"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="1000px"
    @close="closeDialog()"
  >
    <div class="chart-data-page-content" v-loading="loading">
      <div class="mb-10">
        <UtcOffsets />
      </div>
      <el-table border :data="tableData" size="small">
        <el-table-column :label="$t('text.mac_address')" prop="podMac">
        </el-table-column>
        <el-table-column :label="$t('text.tag_timestamp')" prop="tagDateTime">
          <template slot-scope="scope">
            {{
              moment
                .utc(scope.row.tagDateTime)
                .tz($store.state.pods.selectedUtcOffset)
                .format('DD/MM/YY')
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('text.tagged_by')"
          prop="taggedBy"
        ></el-table-column>
        <el-table-column :label="$t('text.period')">
          <template slot-scope="scope">
            <div>
              fr:
              {{
                moment
                  .utc(scope.row.fromDate)
                  .tz($store.state.pods.selectedUtcOffset)
                  .format('DD/MM/YY @ hh:mma')
              }}
            </div>
            <div>
              to:
              {{
                moment
                  .utc(scope.row.toDate)
                  .tz($store.state.pods.selectedUtcOffset)
                  .format('DD/MM/YY @ hh:mma')
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('text.tag')" prop="tag">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.tag" :key="index">
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('text.notes')"
          prop="notes"
        ></el-table-column>
      </el-table>
      <div class="mt-30 dark-font bold-font">
        {{ $t('text.recent_data_for') }}
      </div>
      <div class="chart-wrapper">
        <div
          id="chart"
          class="mt-10"
          :style="{
            width: '100%',
            height: '400px'
          }"
        ></div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        :loading="exportLoading"
        @click="exportData()"
        >{{ $t('text.export') | firstLetterCapitalize }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.close') | firstLetterCapitalize
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import { converFile } from '../../../utils/utils'
import UtcOffsets from '@/components/UtcOffsets'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      tableData: [],
      id: '',
      loading: false,
      source: [],
      chart: '',
      exportLoading: false
    }
  },
  components: {
    UtcOffsets
  },
  watch: {
    '$store.state.pods.selectedUtcOffset': function() {
      this.calculateChartSource()
      this.initChart()
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.getDetail()
    },
    closeDialog() {
      this.chart.clear()
      this.dialogVisible = false
    },
    firstLetterCapitalize(val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    getDetail() {
      this.loading = true
      ApiService.GetDataTagById(this.id)
        .then(response => {
          this.loading = false
          response.data.tag.tag = response.data.tag.tag.split(',')
          this.$set(this.tableData, 0, response.data.tag)

          this.source = [
            ['timeValue', 'sensor1Value', 'sensor2Value', 'timeStamp']
          ]
          let vm = this
          response.data.tagDetail.forEach(item => {
            vm.source.push([
              '',
              item.sensor1Value,
              item.sensor2Value,
              moment(item.timeStamp).format('YYYY-MM-DD HH:mm:ss')
            ])
          })
          if (this.source.length <= 1) {
            this.source.push(['', 0, 0, ''])
          }
          this.calculateChartSource()
          this.initChart()
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    calculateChartSource() {
      let vm = this
      this.source = this.source.map((item, index) => {
        let obj = item
        if (index > 0) {
          obj[0] = moment
            .utc(item[3])
            .tz(vm.$store.state.pods.selectedUtcOffset)
            .format('YYYY-MM-DD HH:mm:ss')
        }
        return obj
      })
      this.source.sort(function(x, y) {
        return moment(x[0]) - moment(y[0])
      })
    },
    initChart() {
      let vm = this
      var dom = document.getElementById('chart')
      this.chart = this.echarts.init(dom)
      this.chart.setOption({
        grid: {
          left: 0,
          right: 10,
          bottom: 50,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            let tooltipStr = `<div>${moment(params[0].axisValue).format(
              'DD/MM/YY HH:mm:ss'
            )}</div>`
            params.forEach(item => {
              if (tooltipStr.indexOf(item.color) < 0) {
                tooltipStr =
                  tooltipStr +
                  `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                    item.color
                  }"></div>${item.seriesName} : ${
                    item.value[item.seriesIndex + 1]
                  }</div>`
              }
            })
            return tooltipStr
          }
        },
        color: ['#008ffb', '#00e396'],
        legend: {
          x: 'center',
          y: 'bottom',
          bottom: 0,
          data: [this.$t('text.sensor') + ' 1', this.$t('text.sensor') + ' 2']
        },
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: ['time', 'sensor1Value', 'sensor2Value'],
          source: this.source
        },
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              showMinLabel: true,
              showMaxLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            nameGap: 40,
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('text.sensor') + ' 1',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'time',
              y: 'sensor1Value'
            }
          },
          {
            name: this.$t('text.sensor') + ' 2',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'time',
              y: 'sensor2Value'
            }
          }
        ]
      })
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    },
    exportData() {
      this.exportLoading = true
      ApiService.ExportDataTagById(this.id)
        .then(response => {
          this.exportLoading = false
          let name =
            this.tableData[0].podMac +
            ' ' +
            moment(this.tableData[0].fromDateWithUtc).format(
              'YYYY-MM-DD HH:mm:ss'
            ) +
            ' to ' +
            moment(this.tableData[0].toDateWithUtc).format(
              'YYYY-MM-DD HH:mm:ss'
            ) +
            'Pod Data.csv'
          converFile(name, response.data)
        })
        .catch(() => {
          this.exportLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
